




























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import CollectorPO from "@/store/entities/devices/collectorpo";
import Url from "@/lib/url";
import XLSX from "@/lib/Common/excel";
@Component({
  components: {},
})
export default class CollectorImportData extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  collectorpo: CollectorPO = new CollectorPO();
  loading: boolean = false;
  areaTree: [] = [];
  modelType: any[] = [];
  actionUrl: string = "";
  importing: boolean = false;
  create() { }
  created() {
    this.getmodelType();
    this.getItemDetail();
    this.actionUrl = Url + "api/services/app/FileCommonService/UploadFile";
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  get list() {
    return this.$data.tableData;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$data.tableData = [];
      this.$emit("save-success");
      this.$emit("input", value);
    }
  }
  downloadtemplat() {
    let a = document.createElement('a');
    a.href = "@/assets/download/collector.xlsx";
    a.click();
  }
  //上传文件
  handleUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();
    //console.log(fileExt)
    if (fileExt == "xlsx" || fileExt == "xls") {
      this.readFile(file);
      this.$data.file = file;
    } else {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("UpLoadFielException"),
      });
    }
    return false;
  }
  // 读取文件
  readFile(file) {
    this.loading = true;
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    // reader.onloadstart = (e) => {
    reader.onerror = (e) => {
      this.$Message.error("文件读取出错");
      this.loading = false;
    };
    reader.onload = (e) => {
      this.$Message.info("文件读取成功");
      const data = (e.target as any).result;
      const { header, results } = XLSX.read(data, "array");
      const tableTitle = header.map((item) => {
        return { title: item, key: item };
      });
      this.$data.tableData = results;
      this.$data.tableTitle = tableTitle;
      this.loading = false;
    };
  }
  //列信息
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      sortable: true,
      width: 160,
      fixed: "left",
      title: this.L("Device") + this.L("Number"),
      key: "no",
    },
    {
      title: this.L("Imei"),
      key: "imei",
      width: 160,
      fixed: "left",
    },
    {
      title: this.L("OperatorResult"),
      key: "operatorResult",
      width: 90,
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps:
                info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      width: 160,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      sortable: true,
      width: 160,
      title: this.L("Logic") + this.L("Address"),
      key: "logicNo",
    },
    {
      title: this.L("IMSI"),
      key: "imsi",
      width: 160,
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Platform") + "Id",
      key: "ispDeviceId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.ispDeviceId },
            },
            params.row.ispDeviceId
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("ISP"),
      key: "isp",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      sortable: true,
      title: this.L("Model") + this.L("ModelInfo"),
      key: "modelId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.modelId;
        let list = JSON.parse(JSON.stringify(this.modelType));
        let info = list.filter((p) => {
          return p.value == id;
        });
        return h("span", info.length > 0 ? info[0].label : this.L("Unknown"));
      },
    },
    {
      sortable: true,
      title: this.L("Device") + this.L("Category"),
      key: "deviceTypeId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.deviceTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "aepTenantId",
      width: 130,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
    },
    {
      sortable: true,
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 90,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
  ];
  //采集器模型
  async getmodelType() {
    await this.$store
      .dispatch("collectormodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //数据字典
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 4;
      });
      info.forEach((ele) => {
        this.$data.collectorTypedetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
      //console.log(info)
      let isp = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      isp.forEach((ele) => {
        this.$data.ispdetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
      //console.log(isp)
    }
  }
  //导入数据
  async importData() {
    if (this.$data.tableData.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("NoDatas"),
      });
      return;
    }
    this.importing = true;
    let res = await this.$store
      .dispatch({
        type: "collector/importCollector",
        data: this.$data.tableData,
      })
      .catch((err) => {
        this.importing = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.importing = false;
    if (res.data.success == true) {
      this.$data.tableData = res.data.result;
    } else {
      this.$Modal.info({
        title: this.L("Tips"),
        content: res.data.error,
      });
    }
  }
  data() {
    return {
      file: null,
      collectorTypedetail: [],
      ispdetail: [],
      tableData: [],
      tableTitle: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
